import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { playerRoute } from './routes';
import { backgroundPlayerWidget } from './widgets';
import { BackgroundPlayer } from './components/BackgroundPlayer/BackgroundPlayer';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: playerRoute,
        meta: {
            plusPaymentPage: 'Player',
            page: 'player',
        },
        component: lazy(() => import('./components/PlayerPage/PlayerPage')),
        fallback: RouteSkeleton,
    });

    ctx.addWidget({
        widget: backgroundPlayerWidget,
        component: BackgroundPlayer,
    });
});

export default scenario;
export * from './routes';
export * from './widgets';
